import { render, staticRenderFns } from "./AuthJourney.vue?vue&type=template&id=61b3e35e&scoped=true"
import script from "./AuthJourney.vue?vue&type=script&lang=js"
export * from "./AuthJourney.vue?vue&type=script&lang=js"
import style0 from "./AuthJourney.vue?vue&type=style&index=0&id=61b3e35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b3e35e",
  null
  
)

export default component.exports